// frontend/src/content/insights/index.js

import { article as a1 } from "./2026/the-problem-is-not-subjectivity";
import { article as a2 } from "./2026/perceptual-ground-truth";
import { article as a3 } from "./2026/two-years-of-listening";
import { article as a4 } from "./2026/authentic-assessment-ai-era";
//import { article as a5 } from "./2026/variability-of-variability";

export const insights = [a1, a2, a3, a4];